<div class="admin-vendor-info">
  @if (VendorId && LocalizationInfo) {
    <app-display-card [justifyContent]="'start'">
      <app-vendor-edit
        [vendorForm]="VendorFormGroup"
        [streetAddressForm]="VendorFormGroup.controls['StreetAddress']"
        [mailingAddressForm]="VendorFormGroup.controls['MailingAddress']"
        [remitToAddressForm]="VendorFormGroup.controls['RemitToAddress']"
        [VendorId]="VendorId"
        [selectedSmallBusinessOptionsFormArray]="
          selectedSmallBusinessOptionsFormArray
        "
        [localizationInfo]="LocalizationInfo"
        [ClientCompanyVendorMap]="ClientCompanyVendorMap"
        [CompanyIdToCompanyOfficesMap]="CompanyIdToCompanyOfficesMap"
        [OperatingStatesForm]="OperatingStatesForm"
      ></app-vendor-edit>
    </app-display-card>

    <div class="action-row justify-end admin-vendor-info__footer">
      <button type="button" class="btn btn-primary" (click)="save()">
        Save changes
      </button>
    </div>
  }

  @if (ExemptVendor) {
    <app-add-edit-exempt-vendor
      [ExemptVendor]="ExemptVendor"
    ></app-add-edit-exempt-vendor>
  }

  @if (ClientRegisteredVendorId) {
    <app-add-edit-client-registered-vendor
      [ClientRegisteredVendor]="ClientRegisteredVendor"
    ></app-add-edit-client-registered-vendor>
  }
</div>
